/** classNames
 * Concatenate classNames by parameterization
 * @param {string} classes - any number of parameters which will be joined
 * @returns {string}
 * @example classNames("class1", "class2", true? "class3": "")
 */
export default function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
